import { render } from "./PackageComparison.vue?vue&type=template&id=4c00d9d4&scoped=true"
import script from "./PackageComparison.vue?vue&type=script&lang=js"
export * from "./PackageComparison.vue?vue&type=script&lang=js"

import "./PackageComparison.vue?vue&type=style&index=0&id=4c00d9d4&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c00d9d4"]])

export default __exports__